export const urlAzure = "https://inspecciones.mariaalmenara.net:8243/" 
